export default {
  "root": "_root_1i3ho_1",
  "label": "_label_1i3ho_1",
  "caption": "_caption_1i3ho_1"
};import "ni:sha-256;IFlOGFnknUrKpvZbgvVXWDXop4yzODRRY9dK8M-73aM";